import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Grid,
  useMediaQuery,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PersonIcon from "@mui/icons-material/Person";
import { useLocation } from "react-router-dom";
import { useAxios, useComponent } from "../../hooks";
import convertDate from "../../utils/convertDate";
import Loader from "../../components/Loader";

export default function StudentProfile() {
  const axios = useAxios();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const location = useLocation();

  const { loader } = useComponent();

  const searchParams = new URLSearchParams(location.search);

  const gatePassId = searchParams.get("gate_pass_id");
  const employee_id = searchParams.get("employee_id");
  const entityID = searchParams.get("entity_id");

  // Loading state
  const [loadingAction, setLoadingAction] = useState(null); // "approve" | "reject" | null

  const [userStatus, setUserStatus] = useState([]);
  const [premises, setPremisesData] = useState([]);

  useEffect(() => {
    loader.start();
    axios({
      url:
        "/admin/gate-pass/get-gate-pass?gate_pass_id=" +
        gatePassId +
        "&employee_id=" +
        employee_id,
      method: "GET",
    })
      .then((response) => {
        if (response.status) {
          setUserStatus(response.data);
        }
        loader.apiComplete();
      })
      .catch((error) => {
        loader.apiComplete();
      });
  }, [gatePassId]);

  useEffect(() => {
    axios({
      url: `/admin/profile/get-premises-banner?premises_id=` + entityID,
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setPremisesData(response.data);
      }
    });
  }, []);

  const handleAction = (status) => {
    if (loadingAction) return; // Prevent double-clicks

    setLoadingAction(status);

    axios({
      url: "admin/gate-pass/approve-gate-pass",
      method: "POST",
      data: { gate_pass_id: gatePassId, status, employee_id: employee_id },
    })
      .then((response) => {
        if (response.status) {
          // ✅ handle success (e.g., navigate or show success message)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        // ✅ Allow retry after request completes
        setLoadingAction(null);
      });
  };

  return (
    <Loader>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="start"
        // minHeight="100vh"
        marginTop={4}
        paddingBottom={2}
        sx={{ backgroundColor: "#ffffffff" }}
      >
        {console.log(userStatus, "userStatus")}
        <Paper
          elevation={4}
          sx={{
            borderRadius: "16px",
            padding: 3,
            width: { xs: "90%", md: "480px" },
            textAlign: "center",
          }}
        >
          {/* Banner */}
          <Box
            component="img"
            src={
              premises.premises_banner ||
              "data:image/png;base64,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"
            }
            alt="Event Banner"
            sx={{
              width: "100%",
              height: "17.5vh",
              borderRadius: "12px",
              boxShadow: 2,
              mb: 3,
            }}
          />

          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
            Request For Outing Pass
          </Typography>

          {/* Info Section */}
          <Box
            sx={{
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              p: 2,
              mb: 3,
              backgroundColor: "#FAFAFA",
            }}
          >
            <Typography
              variant="subtitle2"
              color="text.secondary"
              mb={1}
              textAlign="left"
              fontWeight={900}
            >
              # 1 {userStatus?.gate_pass_id}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {[
              {
                label: "Name",
                value:
                  userStatus?.visitor_info?.first_name +
                  " " +
                  userStatus?.visitor_info?.last_name,
              },
              { label: "Hostel", value: userStatus?.config_name },

              {
                label: "Time for Gate Pass",
                value: `${convertDate(userStatus?.from_time)} - ${convertDate(
                  userStatus?.till_time
                )}`,
              },
              {
                label: "Purpose of Request",
                value: userStatus?.purpose,
              },
              { label: "Location", value: userStatus?.visit_location },
              {
                label: "Status",
                value: userStatus?.status?.toUpperCase(),
              },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { sm: "center" },
                  mb: 2,
                  wordBreak: "break-word",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    // color: "#B0BEC5",
                    minWidth: { sm: "160px", xs: "auto" },
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    // color: "#FFFFFF",
                    ml: { sm: 0.5, xs: 0 },
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Divider sx={{ borderColor: "rgba(255,255,255,0.1)" }} />

          {/* Buttons */}
          <Box
            display="flex"
            justifyContent="space-between"
            mt={2}
            gap={2}
            flexWrap="wrap"
          >
            <Button
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: "#ff0000ff",
                "&:hover": { backgroundColor: "#ff2323ff" },
                flex: 1,
              }}
              disabled={!!loadingAction}
              onClick={() => handleAction("reject")}
            >
              {loadingAction === "reject" ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Reject"
              )}
            </Button>

            <Button
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: "#18e86eff",
                "&:hover": { backgroundColor: "#11d061ff" },
                flex: 1,
              }}
              disabled={!!loadingAction}
              onClick={() => handleAction("approve")}
            >
              {loadingAction === "approve" ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Approve"
              )}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Loader>
  );
}
